import Button from "components/form/Button";
import React, { Fragment } from "react";

const UpdatePaymentConfirm = ({
  setShowPopup,
  handleUpdate,
  isBTNLoading,
}: {
  setShowPopup: React.Dispatch<React.SetStateAction<boolean>>;
  handleUpdate: () => void;
  isBTNLoading?: boolean;
}) => {
  return (
    <Fragment>
      <div className="pt-5 w-full  lg:text-xl text-txtPrimary lg:leading-[30px] leading-[24px]">
        By enabling automatic payments, future invoices will be charged
        automatically to the selected payment method.
        <p className="font-bold">
          This will not affect any invoices that have already been issued.
        </p>
        <br />
        <br />
        Are you sure you want to continue?
      </div>
      <div className="lg:pt-[30px] pt-5 w-full flex lg:justify-end justify-center item-end gap-5">
        <Button
          text="Cancel"
          variant="white"
          className="lg:w-fit w-full"
          isDisabled={isBTNLoading}
          onClick={() => setShowPopup(false)}
        />
        <Button
          text="OK"
          className="lg:w-fit w-full"
          onClick={handleUpdate}
          isLoading={isBTNLoading}
        />
      </div>
    </Fragment>
  );
};

export default UpdatePaymentConfirm;
